import { Print } from "@mui/icons-material";
import { Button } from "@mui/material";
import { AxiosResponse } from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import ReactToPrint from "react-to-print";
import invoiceApi from "../../../../api/invoices/invoiceApi";
import DownloadButton from "../../../../components/Table/components/DownloadButton/DownloadButton";
import { useErrorStatus } from "../../../../context/AuthorizationContext";
import { ConfigContext } from "../../../../context/ConfigContext";
import { DealerAccountContext } from "../../../../context/DealerAccountContext";
import {
  CANADA_DEALER_LOCATION,
  CANADA_INVOICE_PDF_ATTACHMENT,
  US_DEALER_LOCATION,
} from "../../../../utils/constants";
import { BlobResponse } from "../../../../utils/downloadFile";

const InvoiceDownloadButton = ({
  sendRef,
  setPrintButtonClicked,
}: {
  sendRef?: any;
  setPrintButtonClicked?: any;
}) => {
  const { INVOICE_SERVICE_URL } = useContext(ConfigContext);
  const { invoiceNumber } = useParams();
  const { dealerAccount, dealerLocation } = useContext(DealerAccountContext);
  const { setErrorStatusCode } = useErrorStatus();
  const { t } = useTranslation("invoices");

  const accountId = dealerAccount?.id as string;
  const downloadPDFButtonText = t("invoiceDetails.label.button.downloadPDF");

  const setShowUnauthorizedError = (isUnauthorized: boolean) => {
    if (isUnauthorized) setErrorStatusCode(401);
  };

  const downloadFunction = (
    token: string,
    lang?: string,
    objTypeCode?: string
  ): Promise<AxiosResponse<BlobResponse>> =>
    invoiceApi.getInvoicePDF(
      INVOICE_SERVICE_URL,
      invoiceNumber || "",
      accountId,
      token,
      objTypeCode,
      dealerLocation,
      lang,
      "",
      dealerAccount?.mruSalesOrg || ""
    );

  const isUsOrCanadaDealer =
    dealerLocation === US_DEALER_LOCATION ||
    dealerLocation === CANADA_DEALER_LOCATION;

  return (
    <>
      {isUsOrCanadaDealer ? (
        <DownloadButton
          downloadButtonProps={{
            downloadFunction,
            isRealTimeDownload: true,
            shouldDisableDownloadButton: false,
            shouldDisableTooltip: true,
            setShowUnauthorizedError,
            buttonText: downloadPDFButtonText,
            objTypeCode:
              dealerLocation === CANADA_DEALER_LOCATION
                ? CANADA_INVOICE_PDF_ATTACHMENT
                : undefined,
          }}
        />
      ) : (
        <ReactToPrint
          content={() => sendRef.current}
          documentTitle={`${accountId}-${invoiceNumber}`}
          onBeforeGetContent={() => {
            setPrintButtonClicked(true);
            return Promise.resolve();
          }}
          onAfterPrint={() => {
            setPrintButtonClicked(false);
          }}
          pageStyle="@page {size: A3 landscape; margin: 1px}"
          trigger={() => (
            <Button
              variant="secondary"
              data-testid="print-button"
              onClick={(e) => {
                e.preventDefault();
                setPrintButtonClicked(true);
              }}
            >
              <Print />
              {t("invoiceDetails.label.button.print")}
            </Button>
          )}
        />
      )}
    </>
  );
};

export default InvoiceDownloadButton;
